















































import { Component, Vue } from "vue-property-decorator";

interface Message {
    areaId: number;
    content: string;
    gmtCreate: string;
    gmtModified: string;
    id: number;
    phone: string;
    socialCreditCode: string;
    verificationCode: string;
}

@Component
export default class MessageCode extends Vue {
    phone = "";
    phoneList: string[] = [];
    socialCreditCode = "";

    currentPage = 1;
    size = 20;
    totalElements = 0;

    dataList: Message[] = [];

    async fetchPhone() {
        const res = await Vue.axios.get(`accounts/phones?accountNo=${this.$store.state.account.no}`);
        this.phoneList = res.data.data;
    }

    async fetchData() {
        this.dataList = [];
        const res = await Vue.axios.get(`https://fc.hongfund.com:8601/api/text/message/list?page=${this.currentPage - 1}&size=${this.size}&phone=${this.phone}&socialCreditCode=${this.socialCreditCode}`);
        this.dataList = res.data.data.content;
        this.totalElements = res.data.data.totalElements;
    }

    async mounted() {
        await this.fetchPhone();
        if (this.phoneList.length > 0) {
            this.phone = this.phoneList[0];
            await this.fetchData();
        }
    }

    handleSizeChange(size: number) {
        this.size = size;
        this.fetchData();
    }
    changePage(page: number) {
        this.currentPage = page;
        this.fetchData();
    }

    search() {
        this.currentPage = 1;
        this.fetchData();
    }
}
